import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=cc3d2a72&scoped=true"
import script from "./addView.vue?vue&type=script&lang=js"
export * from "./addView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3d2a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc3d2a72')) {
      api.createRecord('cc3d2a72', component.options)
    } else {
      api.reload('cc3d2a72', component.options)
    }
    module.hot.accept("./addView.vue?vue&type=template&id=cc3d2a72&scoped=true", function () {
      api.rerender('cc3d2a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Operations/orderManage/addView.vue"
export default component.exports